var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-box"},[_c('div',{staticClass:"tips-item",on:{"click":_vm.scrollToTop}},[_c('el-image',{staticStyle:{"width":"86px","height":"86px"},attrs:{"src":require('@/assets/common/tip.png'),"fit":"contain"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }